<style>
  .step-segment { height: 8px; border-radius: 4px; transition: background-color 0.3s ease; }
</style>
<div class="row justify-content-center">
  <div class="col-12 col-md-10 col-xxl-6">
    <div class="section-header mb-4">
      <h1 [class]="{'text-center': activeStep === 4}" class="h5 text-colonial">{{activeStep === 4 ? `Id del reclamo aperturado: ${claimId}` : 'Abre tu Reclamo'}}</h1>
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-12 col-md-10 col-xxl-6">
    <div class="row">
      <div class="col">
        <div class="card">
          @if(!isIntermediary || idNumber){
            <div class="card-header bg-white pt-3">
              <h4 class="fs-5 text-colonial">{{ activeStep == 4 ? 'Reclamo aperturado exitosamente' : 'Completa la información' }}</h4>
              <div class="d-flex gap-2 mb-3">
                @for (step of stepsArray; track step) {
                  <div class="step-segment flex-fill"
                       [style.background-color]="activeStep >= step ? '#9a0513' : '#dee2e6'">
                  </div>
                }
              </div>
              <p class="text-muted small mb-1">
                <span class="fw-semibold">Paso {{ activeStep }} de {{ totalSteps }}:</span> {{ stepTitle }}
              </p>
              <div class="d-flex align-items-center gap-1">

                @if(policySelected) {
                  <div class="bg-light py-1 px-2 d-flex gap-2 text-muted mt-1 small align-items-center rounded-3">
                    <span class="material-symbols-outlined text-muted" style="font-size: 22px;"> recent_actors </span>
                    {{policySelected.policyNumber | mask: policyMask}}
                    @if(vehiclePolicySelected && vehiclePolicySelected.policy.vehicleInfo){
                      <span> / {{vehiclePolicySelected.policy.vehicleInfo.registrationNumber}}</span>
                    }
                  </div>
                }
              </div>

            </div>
          }
          <div class="card-body">
            @if(isIntermediary && !idNumber){
              <div class="d-flex flex-column align-items-center justify-content-center gap-2">
                <span class="material-symbols-outlined">
                report
                </span>
                <label>No se pudo encontrar el cliente</label>
              </div>
            }@else{
              @if(activeStep === 1){
                <app-policy-step (onGoBack)="onBackPressed()" (onPolicySelected)="onPolicySelected($event)" [idNumber]="idNumber" [policyFilter]="PolicyType.Vehicle" [redirectToPaymentOnPending]="true"></app-policy-step>
              }
              @else if(activeStep === 2 && policySelected) {
                <app-vehicle-step (onGoBack)="onBackPressed()" (onVehicleSelected)="onVehiclePolicySelected($event)" [value]="policySelected"></app-vehicle-step>
              }
              @else if(activeStep === 3 && vehiclePolicySelected) {
                <app-form-step (onFormCompleted)="onFormCompleted($event)" (onGoBack)="onBackPressed()" [value]="policySelected" [vehicle]="vehiclePolicySelected"></app-form-step>
              }
              @else if(activeStep === 4) {
                <app-claim-rate [claimId]="claimId"></app-claim-rate>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
